<script setup lang="ts">
import { BookOpen, Mail, MapPin, Phone } from '@lucide/vue'
import { siteConfig } from './site-config'
const year = new Date().getFullYear()
</script>

<template>
  <footer id="company" class="app-footer">
    <div class="pf-container">
      <div class="app-footer__main">
        <div class="app-footer__intro">
          <span class="app-footer__brand"><BookOpen :size="20" aria-hidden="true" />{{ siteConfig.name }}</span>
          <p>连接知识与实践，让每一份热爱成为专业能力。</p>
        </div>
        <div class="app-footer__company">
          <h2>公司信息</h2>
          <p>{{ siteConfig.company || '专注职业教育数字化，陪伴每一步成长。' }}</p>
          <div v-if="siteConfig.email || siteConfig.phone" class="app-footer__contacts">
            <a v-if="siteConfig.email" :href="`mailto:${siteConfig.email}`"><Mail :size="14" aria-hidden="true" />{{ siteConfig.email }}</a>
            <a v-if="siteConfig.phone" :href="`tel:${siteConfig.phone}`"><Phone :size="14" aria-hidden="true" />{{ siteConfig.phone }}</a>
          </div>
        </div>
        <div class="app-footer__mission"><MapPin :size="16" aria-hidden="true" /><span>立足职教 · 面向未来</span></div>
      </div>
      <div class="app-footer__bottom">
        <span>© {{ year }} {{ siteConfig.company || siteConfig.name }}. 保留所有权利。</span>
        <a v-if="siteConfig.icp" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{{ siteConfig.icp }}</a>
        <span>以学习者为中心，以实践为方向</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.app-footer { margin-top: auto; border-top: 1px solid var(--pf-border); background: var(--pf-surface); }
.app-footer__main { display: flex; justify-content: space-between; gap: 40px; padding: 32px 0 28px; }
.app-footer__brand { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; color: var(--pf-text); font-size: 16px; font-weight: 600; }
.app-footer__brand svg { flex-shrink: 0; color: var(--pf-accent); }
.app-footer p, .app-footer__contacts { color: var(--pf-text-tertiary); font-size: 12px; }
.app-footer__company h2 { margin-bottom: 10px; font-size: 13px; font-weight: 500; }
.app-footer__contacts { display: flex; flex-wrap: wrap; gap: 16px; margin-top: 10px; }
.app-footer__contacts a, .app-footer__mission { display: flex; align-items: center; gap: 7px; }
.app-footer__mission { align-self: center; color: var(--pf-text-tertiary); font-size: 12px; }
.app-footer__bottom { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 12px; border-top: 1px solid var(--pf-border); padding: 17px 0; color: var(--pf-text-tertiary); font-size: 11px; }
.app-footer a:hover { color: var(--pf-accent); }
@media (max-width: 767px) {
  .app-footer__main { flex-direction: column; gap: 24px; padding: 28px 0; }
  .app-footer__mission { align-self: flex-start; }
  .app-footer__bottom { flex-direction: column; gap: 6px; }
}
</style>
